import { Injectable } from '@angular/core'
import { ExecuteDeleteAPI, ExecuteGetAPI, ExecutePostAPI, ExecutePutAPI } from './execute_api-calls'

@Injectable()
export class PerformanceDashboardAPIs {
  async GetPerformanceFilters () {
    const path = '/dashboard/filters'
    const messages = {
      success: '---> API Call Successful: Get Performance Filters',
      error: 'Error retrieving performance filters.'
    }

    const response = await ExecuteGetAPI(path, this, messages)

    if (response && response.is_success) {
      return response.data
    }
  }

  async GetLowerPerformanceFilters (data) {
    const path = '/dashboard/filters'
    const messages = {
      success: '---> API Call Successful: Get Lower Performance Filters',
      error: 'Error retrieving lower performance filters.'
    }

    const response = await ExecutePostAPI(path, this, data, messages)

    if (response && response.is_success) {
      return response.data
    }
  }

  async GetPerformanceData (filters) {
    const path = '/dashboard/data'
    const messages = {
      success: '---> API Call Successful: Get Performance Data',
      error: 'Error retrieving performance data.'
    }

    const response = await ExecutePostAPI(path, this, filters, messages)

    if (response && response.is_success) {
      return response.data
    }
  }

  async ExportPerformanceDashboardPdf (data) {
    const path = '/generate_pdf'
    const messages = {
      success: '---> API Call Successful: Export Performance Data',
      error: 'Error exporting performance data.'
    }

    const response = await ExecutePostAPI(path, this, data, messages)
    console.log('ExportPerformanceDashboardPdf response:', response)

    if (response && response.is_success) {
      return response.data
    }
  }
}
